import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getBlogPosts = (category) =>
  axios.get(`${API}/blog`, { params: category ? { category } : {} }).then((r) => r.data);

export const getBlogPost = (slug) =>
  axios.get(`${API}/blog/${slug}`).then((r) => r.data);

export const submitContact = (data) =>
  axios.post(`${API}/contact`, data).then((r) => r.data);

export const submitLead = (data) =>
  axios.post(`${API}/leads`, data).then((r) => r.data);
